import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { FC, ReactElement, useEffect, useState } from 'react'
import styled, { ThemeProvider, createGlobalStyle } from 'styled-components'
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'
import ExampleComponent from 'components/ExampleComponent'
import Header from 'components/Header'

const defaultProperties: { [key: string]: string } = {
  module: 'animation',
  headerTitle: "Ce qu'on sait des causes du Covid long",
  headerText:
    'Le Français interpellé en région catalane était sous le coup d’un mandat d’arrêt international pour vol organisé avec armes en 2019 dans le canton de Vaud.',
  headerSup: 'Visualisation',
}

const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  properties = defaultProperties,
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]

  const theme = {
    purpleBright: '#BA7FB7',
    purpleMain: '#A757A3',
    purpleDark: '#7A3F77',
    purpleDarker: '#512A4F',
    colorMode: colorMode,
    grayLight: '#f8f9fc',
    grayMain: '#f1f3f9',
    grayDark: '#dee3ed',
  }

  const [container, setContainer] = useState<HTMLDivElement | null>(null)

  const modules: { [key: string]: ReactElement } = {
    header: (
      <Header
        title={properties?.headerTitle}
        text={properties?.headerText}
        sup={properties?.headerSup}
        tenant={tenant}
      />
    ),
    animation: <ExampleComponent />,
  }

  useEffect(() => {
    if(container) {
      // @ts-ignore
      const host = container.getRootNode().host
      const parent = host?.parentElement
      
      if(properties?.module === 'header' && parent) {
        parent.style.setProperty('z-index', '999')
      }
    }
  }, [container])

  return (
    <AppContainer ref={setContainer} className={globalClasses.join(' ')}>
      <ThemeProvider theme={theme}>
        {properties?.module && modules[properties.module]}
      </ThemeProvider>
    </AppContainer>
  )
}

const AppContainer = styled(TamediaStyles)`
  position: relative;
  font-family: var(--font-serif);
  font-size: 1.8rem;
  line-height: 3rem;
`

export default MainComponent
